import { render } from "./px-modal-message.vue?vue&type=template&id=03ca62a8&scoped=true&ts=true"
import script from "./px-modal-message.vue?vue&type=script&lang=ts"
export * from "./px-modal-message.vue?vue&type=script&lang=ts"

import "./px-modal-message.vue?vue&type=style&index=0&id=03ca62a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ca62a8"]])

export default __exports__